import { TObject } from 'utils/types';

import { REDIRECT_MODE } from './constants';
import {
  IAdapter,
  IAuthDefinition,
  ICheckStatus,
  IHandleWebhook,
  IPayout,
  ISendPayment,
} from './types';

export const normalizeAuthDefinition = (data: TObject): IAuthDefinition => {
  return {
    headers: (data?.headers as TObject) || {},
    httpMethod: (data?.httpMethod as string) || '',
    responseBodyType: (data?.responseBodyType as string) || '',
    template: (data?.template as string) || '',
    tokenPath: (data?.tokenPath as string) || '',
    urlTemplate: (data?.urlTemplate as string) || '',
  };
};

export const normalizeAdapter = (data: TObject): IAdapter => {
  return {
    code: (data?.code as string) || '',
    created: (data?.created as string) || '',
    hash: (data?.hash as string) || '',
  };
};

export type ISendPaymentData = TObject & {
  headers: TObject;
  resultMapping: TObject;
};

export const normalizeSendPayment = (data: ISendPaymentData): ISendPayment => {
  return {
    authDefinition: data?.authDefinition
      ? normalizeAuthDefinition(data.authDefinition as TObject)
      : null,
    authEnabled: !!data?.authEnabled,
    code: (data?.code as string) || '',
    created: (data?.created as string) || '',
    headers: (data?.headers as TObject) || {},
    httpMethod: (data?.httpMethod as string) || '',
    id: (data?.id as number) || 0,
    paymentMethod: (data?.paymentMethod as string) || '',
    redirectEnabled: !!data?.redirectEnabled,
    redirectMode: (data?.redirectMode as string) || REDIRECT_MODE.SIMPLE,
    redirectParameters: (data?.redirectParameters as TObject) || {},
    redirectUrlTemplate: (data?.redirectUrlTemplate as string) || '',
    requestTimeoutSeconds: (data?.requestTimeoutSeconds as number) ?? null,
    responseBodyType: (data?.responseBodyType as string) || '',
    resultMapping: (data?.resultMapping as TObject) || {},
    signatureEnabled: !!data.signatureEnabled,
    signatureTemplate: (data?.signatureTemplate as string) || '',
    signatureType: (data?.signatureType as string) || '',
    stateAfterRedirect: (data?.stateAfterRedirect as string) || '',
    template: (data?.template as string) || '',
    updated: (data?.updated as string) || '',
    urlTemplate: (data?.urlTemplate as string) || '',
  };
};

export type IHandleWebhookData = TObject & {
  resultMapping: TObject;
};

export const normalizeHandleWebhook = (data: IHandleWebhookData): IHandleWebhook => {
  return {
    ackBodyTemplate: (data?.ackBodyTemplate as string) || null,
    ackEnabled: !!data?.ackEnabled,
    ackStatusCode: (data?.ackStatusCode as number) || null,
    code: (data?.code as string) || null,
    created: (data?.created as string) || null,
    customerTokenPath: (data?.customerTokenPath as string) || null,
    customerTokenSource: (data?.customerTokenSource as string) || null,
    id: (data?.id as number) || null,
    paymentMethod: (data?.paymentMethod as string) || null,
    resultMapping: (data?.resultMapping as TObject) || {},
    tokenExtractionEnabled: !!data?.tokenExtractionEnabled,
    transactionType: (data?.transactionType as string) || null,
    updated: (data?.updated as string) || null,
    webhookBodyType: (data?.webhookBodyType as string) || null,
  };
};

export type IPayoutData = TObject & {
  headers: TObject;
  resultMapping: TObject;
};

export const normalizePayout = (data: IPayoutData): IPayout => {
  return {
    authDefinition: data?.authDefinition
      ? normalizeAuthDefinition(data.authDefinition as TObject)
      : null,
    authEnabled: !!data?.authEnabled,
    code: (data?.code as string) || '',
    created: (data?.created as string) || '',
    headers: (data?.headers as TObject) || {},
    httpMethod: (data?.httpMethod as string) || '',
    id: (data?.id as number) || 0,
    paymentMethod: (data?.paymentMethod as string) || '',
    requestTimeoutSeconds: (data?.requestTimeoutSeconds as number) ?? null,
    responseBodyType: (data?.responseBodyType as string) || '',
    resultMapping: (data?.resultMapping as TObject) || {},
    signatureEnabled: !!data.signatureEnabled,
    signatureTemplate: (data?.signatureTemplate as string) || '',
    signatureType: (data?.signatureType as string) || '',
    template: (data?.template as string) || '',
    updated: (data?.updated as string) || '',
    urlTemplate: (data?.urlTemplate as string) || '',
  };
};

export type ICheckStatusData = TObject & {
  headers: TObject;
  resultMapping: TObject;
};

export const normalizeCheckStatus = (data: ICheckStatusData): ICheckStatus => {
  return {
    authDefinition: data?.authDefinition
      ? normalizeAuthDefinition(data.authDefinition as TObject)
      : null,
    authEnabled: !!data?.authEnabled,
    code: (data?.code as string) || '',
    created: (data?.created as string) || '',
    headers: (data?.headers as TObject) || {},
    httpMethod: (data?.httpMethod as string) || '',
    id: (data?.id as number) || 0,
    paymentMethod: (data?.paymentMethod as string) || '',
    requestTimeoutSeconds: (data?.requestTimeoutSeconds as number) ?? null,
    responseBodyType: (data?.responseBodyType as string) || '',
    resultMapping: (data?.resultMapping as TObject) || {},
    signatureEnabled: !!data.signatureEnabled,
    signatureTemplate: (data?.signatureTemplate as string) || '',
    signatureType: (data?.signatureType as string) || '',
    template: (data?.template as string) || '',
    transactionType: (data?.transactionType as string) || null,
    updated: (data?.updated as string) || '',
    urlTemplate: (data?.urlTemplate as string) || '',
  };
};
